<template>
  <div class="box">
    <div class="head-b">
      <b>运动生涯</b>
      <img :src="goldBg"/> {{ detail.gold }}
      <img :src="sliverBg"/> {{ detail.silver }}
      <img :src="bronzeBg"/> {{ detail.bronze }}
    </div>
    <a-timeline>
      <a-timeline-item v-for="(item,index) in keyArr" :key="index">
        <h1>{{ item }}</h1>
        <div class="year-list" v-for="(it,ind) in yearData[item]" :key="ind">
          <h3><font style="margin:0 10px;">{{ it.matchBeginTime.substring(5, 10) }}</font>{{ it.matchName }}</h3>
          <div v-if="it.eventDetail !== null">
            <div v-for="(i,j) in it.eventDetail" :key="j" class="rank-box">
              {{ i.combatName }}/{{ i.combatDetailName }}/{{ i.sex === '1' ? '男子/' : (i.sex === '2' ? '女子/' : '') }}{{ i.weight }}
              <img v-if="i.rank === 1" :src="goldBg"/>
              <img v-else-if="i.rank === 2" :src="sliverBg"/>
              <img v-else-if="i.rank === 3" :src="bronzeBg"/>
              <span v-else style="margin-left:20px;font-weight:bold;">第{{ i.rank }}名</span>
            </div>
          </div>
        </div>
      </a-timeline-item>
    </a-timeline>
  </div>
</template>

<script>
export default {
  data () {
    return {
      programId: this.$route.query.programId,
      detail: {},
      goldBg: require('@comm/assets/jin.png'),
      sliverBg: require('@comm/assets/yin.png'),
      bronzeBg: require('@comm/assets/tong.png'),
      data: [],
      yearData: {},
      keyArr: []
    }
  },
  created () {
    this.detail = JSON.parse(decodeURI(this.$route.query.detail))
    this.findData()
  },
  methods: {
    findData () {
      this.$api.match.playerEvents({cardId: this.detail.cardId, programId: this.programId, year: -1, pageNo: 1, pageSize: 20}).then(res => {
        if (res.status === 0) {
          this.data = res.data
          this.data.forEach(element => {
            let year = element.matchBeginTime.substring(0, 4)
            if (this.yearData[year] === undefined) {
              this.yearData[year] = []
            }
            this.yearData[year].push(element)
          })
          this.keyArr = Object.keys(this.yearData).sort(function (a, b) {
            return a - b > 0 ? 0 : 1 // 升序
          })
          this.$forceUpdate()
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.box{
  width: 1200px;
  margin: 0 auto;
  border-top: 5px solid #eeecec;
}
.head-b{
  margin-top:30px;margin-bottom:30px;font-size: 16px;
}
.head-b img{
  width: 20px;
  margin-left: 20px;
}
.head-b b{
  margin-right: 10px;
}
.year-list{
  width: 100%;
  background: rgb(241, 241, 241);
  border-radius:10px;
  padding: 10px;
  margin-bottom: 20px;
}
.rank-box{
  background: white;
  margin-left: 20px;
  margin-bottom: 20px;
  padding: 10px;
}
.rank-box img{
  width: 20px;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/components/module/SkillCareer.vue